import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

/*if (environment.production) {
  enableProdMode();
}*/

platformBrowserDynamic().bootstrapModule(AppModule);
// Set Favicon
window.document.getElementById('favicon').setAttribute('href', '/assets/img/favicons.ico');
// Set Apple-touch-icon
window.document.getElementById('apple-touch-icon').setAttribute('href', '/assets/img/apple-icon-book-meeting.png');



// WEBPACK FOOTER //
// /app/src/main.ts